import {Component, OnInit} from '@angular/core';
import {Router, Params} from '@angular/router';
import {AppComponent} from "../app.component";
import {RecursoService} from "../pedir-recurso/recurso.service";
import {Recurso} from "../pedir-recurso/recurso";

declare var jQuery: any;

@Component({
  selector: 'app-avaliar-recurso',
  templateUrl: './avaliar-recurso.component.html',
  styleUrls: ['./avaliar-recurso.component.css'],
})
export class AvaliarRecursoComponent extends AppComponent implements OnInit {
	recurso: Recurso;
	homologa_1: string;
	homologa_2: string;
	desabilitado: boolean;
	q: any[] = new Array(2);
	carregado: boolean = false;

	ngOnInit(): void {
		if (!(this.islogged() && (this.isParecerista() || this.isAdmin()))) 
            this.router.navigateByUrl('inicio'); 
		else {
			let trabalhoId: number;
			this.route.params.subscribe(params => trabalhoId = +params['id_t']);
			this.recursoService.retornarRecurso(trabalhoId).then(recurso => {
				this.trabalhoService.getTrabalho(trabalhoId).then(trabalho => {
					this.questionService.getQuestions(trabalho.evento_id).then(perguntas => {
						console.log(recurso);
						this.recurso = recurso;
						this.q[0] = new Array(perguntas[recurso.item_1 - 1].nota_maxima * 10 + 1);
						if (recurso.item_2)
							this.q[1] = new Array(perguntas[recurso.item_2 - 1].nota_maxima * 10 + 1);
						if (recurso.item_1_just) {
							jQuery("form :input").prop("disabled", this.desabilitado = true);
							jQuery("form :input").prop("readonly", true);
							jQuery("#voltar").prop("disabled", false);
							if (recurso.nova_nota_1) 
								this.homologa_1 = 'Sim';
							else
								this.homologa_1 = 'Não';
							if (recurso.nova_nota_2) 
								this.homologa_2 = 'Sim';
							else
								this.homologa_2 = 'Não';
						}
						this.carregado = true;
					});
				});
			});
		}
	}
	
	onSubmit(): void {
		this.recursoService.avaliarRecurso(this.recurso).then(response => this.goBack());
	}

}



// WEBPACK FOOTER //
// ./src/app/avaliar-recurso/avaliar-recurso.component.ts